<h2>{{ "dtmMainPageLib.subpage.whereYouCanFly.faq.title" | transloco }}</h2>
<dtm-ui-accordion>
    <dtm-ui-expandable-panel [hasHeaderSeparator]="false" *ngFor="let index of questionIndexes$ | ngrxPush">
        <h3 headerSlot>{{ index }}. {{ "dtmMainPageLib.subpage.whereYouCanFly.faq.questions." + index + ".question" | transloco }}</h3>

        <p [innerHtml]="'dtmMainPageLib.subpage.whereYouCanFly.faq.questions.' + index + '.answer' | transloco : translationArguments"></p>
    </dtm-ui-expandable-panel>
</dtm-ui-accordion>
